import { createContext, useContext } from "react";
import type { StepUpPurpose } from "@/api/step-up";

export type StepUpRunOpts = {
  /** Ask for the code before the first try (the write surely needs it). */
  upfront?: boolean;
  /** Finishes "To …, enter the code": e.g. "turn on Razorpay on iOS". */
  action?: string;
};

export type StepUpRun = <T>(purpose: StepUpPurpose, write: (token: string | null) => Promise<T>, opts?: StepUpRunOpts) => Promise<T>;

export const StepUpContext = createContext<{ run: StepUpRun } | null>(null);

/** The email-code step-up runner (see StepUpDialog). Needs <StepUpProvider> above. */
export const useStepUp = () => {
  const ctx = useContext(StepUpContext);
  if (!ctx) throw new Error("useStepUp needs <StepUpProvider>");
  return ctx;
};
